import { PrimaryLoader } from "./Loader"

function Loading({className}) {
    return (
        <div className={`items-center justify-center ${className}`}>
            <PrimaryLoader />
        </div>
    )
}

export default Loading
